import { CSADMIN_ROLE } from 'common/Constants';
import { safeStringCompare } from './strings';

const hasRole = (userRoles, roleName) => (userRoles || []).some((userRole) => safeStringCompare(roleName, userRole));

const hasAnyRole = (userRoles = [], roleNames = []) => roleNames.some((roleName) => hasRole(userRoles, roleName));

const userHasAnyRole = (authUser, roleNames = [CSADMIN_ROLE]) => {
  const userRoles = authUser?.csaUserAuthData?.idTokenClaims?.roles;
  return hasAnyRole(userRoles, roleNames);
};

export { hasAnyRole, hasRole, userHasAnyRole };
